import styled from 'styled-components';
import { CountdownTimer } from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';
import type { TooltipProps } from '@elfsight/widget-modal';
import { Tooltip as LibTooltip } from '@elfsight/widget-modal';

export function Tooltip({
  children,
  title = DefaultTooltipTitle,
  ...forwardingProps
}: TooltipProps) {
  return (
    <LibTooltip
      {...forwardingProps}
      title={title}
      background="#fff"
      fontColor="#111"
    >
      {children}
    </LibTooltip>
  );
}

const Title = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  text-align: left;
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
`;

const DefaultTooltipTitle = (
  <Title>
    <Icon component={CountdownTimer} size={16} />
    Timer scheduled to start later.
    <br />
    Currently, only you can see this timer.
  </Title>
);
